export default __webpack_public_path__ + "static/media/pentest_3.9198380b.svg";